export const LaunchDates = {
  hostKitV2: new Date('04/01/2020'),
  rewards: new Date('10/01/2020'),
  tastingKit: new Date('03/14/2021'),
};

export const ohwImageUploads = `https://ohw-image-uploads.s3.amazonaws.com`;
export const fallbackProductImage = 'OH-Logo_Icon-Black.jpg';
